import { runTalkboxFunctions } from '../functions/talkbox';

const STORAGE_KEY = 'wasabiCampaignPopupLastSeen';

const getTodayKey = () => {
	const now = new Date();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	const day = String(now.getDate()).padStart(2, '0');

	return `${now.getFullYear()}-${month}-${day}`;
};

const markPopupSeenToday = () => {
	localStorage.setItem(STORAGE_KEY, getTodayKey());
};

const hasSeenPopupToday = () => localStorage.getItem(STORAGE_KEY) === getTodayKey();

const trackCampaignEvent = (eventName) => {
	document.dispatchEvent(new CustomEvent('wasabi:campaign-popup', {
		detail: { eventName }
	}));
};

const openCampaignPopup = (popup) => {
	popup.classList.add('active');
	document.body.classList.add('js__popup-active');
	document.querySelector('#js__body')?.classList.add('js__popup-active');
	markPopupSeenToday();
	trackCampaignEvent('Campaign Popup View');
};

const closeCampaignPopup = (popup) => {
	popup.classList.remove('active');
	document.body.classList.remove('js__popup-active');
	document.querySelector('#js__body')?.classList.remove('js__popup-active');
	markPopupSeenToday();
};

const handleCampaignSignup = (popup, form) => {
	const submitButton = form.querySelector('.js-campaign-signup-trigger');
	const formContainer = popup.querySelector('.popup-campaign__form-container');
	const successPanel = popup.querySelector('.js-campaign-success');
	const successHeading = popup.querySelector('.js-campaign-success-heading');
	const successMessage = popup.querySelector('.js-campaign-success-message');
	const firstNameInput = form.querySelector('#campaign_signup_first_name');
	const lastNameInput = form.querySelector('#campaign_signup_last_name');
	const emailInput = form.querySelector('#campaign_signup_email');
	const optInInput = form.querySelector('#campaign_signup_email_optin');
	const tagIdInput = form.querySelector('[name="talkbox_tag_id"]');
	const tagStringInput = form.querySelector('[name="talkbox_tag_string"]');
	const customerTypeSelected = form.querySelector('input[name="customer_type"]:checked');

	if ( !submitButton ) {
		return;
	}

	submitButton.addEventListener('click', (event) => {
		event.preventDefault();

		if ( !form.checkValidity() ) {
			form.reportValidity();
			return;
		}

		if ( !optInInput?.checked ) {
			optInInput?.reportValidity();
			return;
		}

		form.classList.add('submitting');

		const customerType = customerTypeSelected?.value || '';

		const ajaxData = {
			first_name: firstNameInput?.value || '',
			last_name: lastNameInput?.value || '',
			email: emailInput?.value || '',
			customer_type: customerType,
			tagId: tagIdInput?.value || '',
			tagString: tagStringInput?.value || '',
			action: 'ajax_talkbox'
		};

		runTalkboxFunctions(ajaxData).then((response) => {
			form.classList.remove('submitting');

			if ( response?.success ) {
				trackCampaignEvent('Campaign Popup Sign Up');
				markPopupSeenToday();

				if ( successHeading ) {
					successHeading.textContent = popup.dataset.successHeading || 'Thank you!';
				}

				if ( response.content && successMessage ) {
					successMessage.innerHTML = response.content;
				}

				formContainer?.classList.add('hidden');
				popup.querySelector('.popup-campaign__title')?.classList.add('hidden');
				popup.querySelector('.popup-campaign__copy')?.classList.add('hidden');
				successPanel?.classList.remove('hidden');
			} else {
				window.alert('Sorry, we could not sign you up right now. Please try again later.');
			}
		});
	});
};

export const campaignPopup = () => {
	const popup = document.querySelector('.popup-campaign');

	if ( !popup || hasSeenPopupToday() ) {
		return;
	}

	const delay = parseInt(popup.dataset.delay, 10) || 5;
	const form = popup.querySelector('#campaign-signup-form');
	const closeButtons = popup.querySelectorAll('.js__close-campaign-popup');

	closeButtons.forEach((button) => {
		button.addEventListener('click', () => {
			trackCampaignEvent('Campaign Popup Dismiss');
			closeCampaignPopup(popup);
		});
	});

	document.addEventListener('keydown', (event) => {
		if ( event.key === 'Escape' && popup.classList.contains('active') ) {
			trackCampaignEvent('Campaign Popup Dismiss');
			closeCampaignPopup(popup);
		}
	});

	if ( form ) {
		handleCampaignSignup(popup, form);
	}

	setTimeout(() => {
		if ( !hasSeenPopupToday() ) {
			openCampaignPopup(popup);
		}
	}, delay * 1000);
};
